import cn from 'classnames';
import type { CSSProperties, FC, FocusEventHandler } from 'react';
import { DateInputUtils, DateUtils } from '@/utils/Date.utils';
import { handleOpenPickerOnArrowDown } from '@/utils/NativePicker.utils';

export interface DateTimePickerNativeProps {
  id?: string;
  value?: string;
  name?: string;
  step?: string;
  min?: string;
  max?: string;
  className?: string;
  style?: CSSProperties;
  onChange?: (value: string) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  disabled?: boolean;
  displaySeconds?: boolean;
  error?: boolean;
  /**
   * Opt in to opening the browser date picker on ArrowDown, matching how a select opens its menu.
   * Off by default because it replaces the native ArrowDown behaviour of stepping the focused
   * date segment, which existing screens rely on.
   */
  openPickerOnArrowDown?: boolean;
}

export const DateTimePickerNative: FC<DateTimePickerNativeProps> = ({
  id,
  value,
  name,
  step,
  min,
  max,
  className,
  style,
  disabled,
  displaySeconds = false,
  error = false,
  openPickerOnArrowDown = false,
  onChange,
  onBlur,
}) => (
  <input
    type="datetime-local"
    id={id}
    data-testid="datetime-picker"
    className={cn(className, { input__error: error })}
    style={{ width: 185, ...style }}
    value={DateInputUtils.toLocalDateTime(value ?? DateUtils.dateTimeNow(), { includeSeconds: displaySeconds })}
    name={name}
    step={step}
    max={DateInputUtils.toLocalDateTime(max, { includeSeconds: displaySeconds })}
    min={DateInputUtils.toLocalDateTime(min, { includeSeconds: displaySeconds })}
    disabled={disabled}
    onChange={(event) => onChange?.(DateInputUtils.localDateTimeToISODateTime(event.target.value))}
    onBlur={onBlur}
    onKeyDown={(event) => handleOpenPickerOnArrowDown(event, openPickerOnArrowDown)}
  />
);
